import { render } from "./profileStats.vue?vue&type=template&id=f89905da&scoped=true"
import script from "./profileStats.vue?vue&type=script&lang=js"
export * from "./profileStats.vue?vue&type=script&lang=js"

import "./profileStats.vue?vue&type=style&index=0&id=f89905da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89905da"]])

export default __exports__